import { render, staticRenderFns } from "./SelectInvoicePrefix.vue?vue&type=template&id=0dd3023e&"
import script from "./SelectInvoicePrefix.vue?vue&type=script&lang=js&"
export * from "./SelectInvoicePrefix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports